import React, { type ReactNode } from 'react';

import { parseTextWithUrls } from './parseTextWithUrls';

export const processMixedContent = (
  children: ReactNode,
  parentElement: HTMLElement | null,
  showUrlsIcons: boolean,
): ReactNode => {
  if (!children) return children;

  return React.Children.map(children, (child) =>
    typeof child === 'string'
      ? parseTextWithUrls(child, parentElement, showUrlsIcons)
      : child,
  );
};
